import { createMiddleware } from 'redux-beacon';
import GoogleTagManager from '@redux-beacon/google-tag-manager';
import {
  PLAY_VIDEO,
  SHARE_SPY_ROLE,
  CLICK_COMPARISON_INVITE_BUTTON,
  COPY_COMPARISON_INVITE_URL,
  SHARE_COMPARISON_INVITE_URL,
  SHOW_DOSSIER_PURCHASE_MODAL,
  BEGIN_DOSSIER_PURCHASE,
  SHOW_DOSSIER_PURCHASE_SUCCESS_MODAL,
} from '../actions/action-types';

const eventsMap = {
  [PLAY_VIDEO]: ({ payload: { eventId } }) => ({
    event: eventId,
  }),
  [SHARE_SPY_ROLE]: ({ payload: { spyRole, socialNetwork } }) => ({
    event: 'spyRoleShare',
    spyRole,
    socialNetwork,
  }),
  [CLICK_COMPARISON_INVITE_BUTTON]: ({ payload: { profileId } }) => ({
    event: 'comparisonInviteButtonClick',
    profileId,
  }),
  [COPY_COMPARISON_INVITE_URL]: ({ payload: { profileId } }) => ({
    event: 'comparisonInviteUrlCopy',
    profileId,
  }),
  [SHARE_COMPARISON_INVITE_URL]: ({
    payload: { profileId, socialNetwork },
  }) => ({
    event: 'comparisonInviteUrlShare',
    profileId,
    socialNetwork,
  }),
  [SHOW_DOSSIER_PURCHASE_MODAL]: () => ({
    event: 'show_dossier_purchase_modal',
  }),
  [BEGIN_DOSSIER_PURCHASE]: ({ payload: { eventCallback, eventTimeout } }) => ({
    event: 'begin_dossier_purchase',
    eventCallback,
    eventTimeout,
  }),
  [SHOW_DOSSIER_PURCHASE_SUCCESS_MODAL]: () => ({
    event: 'show_dossier_purchase_success_modal',
  }),
};

const createGtmMiddleware = () => {
  const gtm = GoogleTagManager();

  return createMiddleware(eventsMap, gtm);
};

export default createGtmMiddleware;
